<template>
    <HeaderContent title="Directory Destination"/>
    <ActionContent ctaText="Destination" :filterDate="false" @action="modal = !modal " />
    <DestinationForm :modal="modal" @update:modal="modal = $event"></DestinationForm>
    <DataTable :data="data" :header="headers" :currentPage="currentPage" :custom-actions="customActions">
    </DataTable>
    <EditDestination 
        :data="modalEdit.data"
        @update:data="modalEdit.data = $event" 
        :modal="modalEdit.show" 
        @update:modal="modalEdit.show = $event"></EditDestination>
    
</template>

<script>
import HeaderContent from '@/components/HeaderContent.vue';
import ActionContent from '@/components/ActionContent.vue';
import DestinationForm from './DestinationForm.vue';
import EditDestination from './action/EditDestination.vue';
import DataTable from '@/components/DataTable.vue';
import destinationDummy from '@/dummy-data/destination.js'
import { ref, reactive } from 'vue'

export default{
    name : 'DestinationIndex',
    components : { HeaderContent, ActionContent, DestinationForm, DataTable, EditDestination },

    setup(){
        const data = destinationDummy
        const modal = ref(false)
        const modalEdit = reactive({
            show: false,
            data : {},
        })
        const headers = ref([
            {key : 'id',label: 'ID',sortable: true,},
            {key : 'code', label : 'Code',sortable: true, },
            {key : 'place_name', label : 'Place Name',sortable: true, },
            {key : 'action', label : 'Action' },

            
        ])
        const customActions = ref([
            {
                label: 'Edit',
                variant: 'success',
                icon: 'fas fa-edit',
                action: (item) => {
                    modalEdit.show = !modalEdit.show
                    modalEdit.data = item
                }
            },
            {
                label: 'Delete',
                variant: 'danger',
                icon: 'fas fa-trash',
                action: (item) => {
                console.log('Delete action clicked for:', item);
                }
            },
            
        ]);
        return {
            data, modal, modalEdit, headers, customActions, 
        }
    }
}
</script>

